import { DateTime } from '@ksyos/date-time';
import { Text } from '@ksyos/design-system';
import type { HearingLossRecipe } from '../../../../common/interfaces/hearingLoss';
import { getProfessionName } from '../../../services/hearingLossService';
import { CardTheme, FixedCard } from '../../elements/molecules/card/Card';

export function HearingLossRecipeCard({
    performedDatetime,
    processActivityId,
    profession,
}: Readonly<HearingLossRecipe>) {
    const title = 'Recept hoorhulpmiddel';
    const linkText = 'Lees verder';
    const linkTo = `/hearingLoss/downloadRecipe/${processActivityId}`;

    return (
        <FixedCard
            body={''}
            cardTitle={title}
            linksText={linkText ? [linkText] : undefined}
            linksTo={linkTo ? [linkTo] : undefined}
            theme={CardTheme.white}
        >
            <Text>
                De Ksyos {getProfessionName(profession)} heeft op{' '}
                <Text fontWeight="medium">{DateTime.from(performedDatetime).format('DD MMMM YYYY')}</Text> het recept
                voor je hoorhulpmiddel voor je klaargezet. Lees hier wat je zelf regelt.
            </Text>
        </FixedCard>
    );
}
